/**
 * User: hella
 * Date: 5/17/14
 * Time: 3:38 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */
'use strict';
var root = "undefined" === typeof global ? window : global;
var $ = require('dibs-jquery-shim');
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,

    init: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },

    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem("dibsy", "");
            this._storage.removeItem("dibsy");
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },

    getItems: function () {
        if (!this._supported) {
            return "localStorage is not supported";
        }
        return this._storage;
    },

    showAllItems: function () {
        var values = this._storage;
        var key;
        var p;
        var val;
        if (!this._supported) {
            if ($.cookie) {
                values = $.cookie(); // retrieves all cookies, but as an object not array
                for (p in values) {
                    if (values.hasOwnProperty(p)) {
                        key = p;
                        val = this.getItem(key);
                    }
                }
                return this;
            }
        }
        var len = this._storage.length;
        var i = 0;
        for (i; i < len; i++) {
            key = this._storage.key(i);
            val = this.getItem(key);
        }
        return this;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            if ($.cookie) {
                $.cookie(key, value, {path: '/'});
            }
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            if ($.cookie) {
                value = $.cookie(key);
                if (value === null && this.data[key]) {
                    value = this.data[key];
                }
            } else {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            if ($.cookie) {
                $.removeCookie(key, {path: '/'});
            }
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();

initializedSessionStorage = SessionStorage.init(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.init(),
    sessionStorage: initializedSessionStorage
};




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/storage.js
// module id = 76
// module chunks = 2 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56